export default function ButtonGroup(options){
    let container = options.container
    let onclick = options.onclick

    let element;

    this.generate = () =>{
        generateButton()
        $(container).html(element)
    }
    
    function generateButton(){
        element = document.createElement('button')
        $(element).addClass('btn btn-sm btn-primary')
        element.type = 'button'
        element.innerHTML = "Grupos"
        element.addEventListener('click', ()=>onclick())
    }
}